import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/app/ui/assets/svg/icon-play-video.svg'


const _hoisted_1 = { class: "rounded-lg border border-gray-lp-1400 p-4" }
const _hoisted_2 = { class: "space-y-2" }
const _hoisted_3 = { class: "text-sm text-gray-lp-300 font-semibold" }
const _hoisted_4 = { class: "text-sm text-gray-lp-300 font-medium" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_7 = {
  key: 0,
  class: "mt-4 space-y-2"
}
const _hoisted_8 = { class: "flex flex-row flex-wrap gap-1 max-w-[calc((40px+0.25rem)*6)]" }
const _hoisted_9 = { class: "relative border border-gray-lp-1400 rounded-lg p-1" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "relative h-10 w-10"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "Play",
  class: "absolute  left-1/4 top-1/4 mt-1 ml-2px -translate-x-1/2 -translate-y-1/2 h-4 w-4 cursor-pointer pointer-events-none"
}, null, -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 3,
  class: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImagePreview = _resolveComponent("ImagePreview")!

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('pusatResolusi.issue')), 1),
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.issueName), 1),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", {
          class: ["text-sm text-gray-lp-300", {
            'whitespace-pre-wrap': _ctx.isExpanded
          }],
          style: {
            display: '-webkit-box',
            overflow: !_ctx.isExpanded ? 'hidden' : 'visible',
            textOverflow: 'ellipsis',
            '-webkit-line-clamp': !_ctx.isExpanded ? '3' : 'unset',
            '-webkit-box-orient': 'vertical',
            maxHeight: !_ctx.isExpanded ? '4em' : 'none'
          }
        }, _toDisplayString(_ctx.description), 7),
        (_ctx.shouldShowToggle)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleExpand && _ctx.toggleExpand(...args))),
                class: "text-red-lp-100 text-sm font-medium hover:underline"
              }, _toDisplayString(_ctx.isExpanded ? _ctx.$t("Lebih sedikit") : _ctx.$t("Selengkapnya")), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.attachment && _ctx.attachment.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.attachment, (item, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: index,
                  class: "relative"
                }, [
                  _createVNode("div", _hoisted_9, [
                    (_ctx.isImageFile(item.ext.replace('.', '')))
                      ? (_openBlock(), _createBlock("div", _hoisted_10, [
                          (
                    ['mp4', 'webm'].includes(
                      item.ext.replace('.', '').toLowerCase()
                    )
                  )
                            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                                _createVNode("video", {
                                  src: item.url,
                                  class: "h-10 w-10 object-cover rounded-lg cursor-pointer relative",
                                  preload: "metadata",
                                  onClick: ($event: any) => (_ctx.openImagePreview(index))
                                }, null, 8, ["src", "onClick"]),
                                _hoisted_12
                              ]))
                            : (_openBlock(), _createBlock("img", {
                                key: 1,
                                src: item.url,
                                alt: item.name,
                                class: "h-10 w-10 object-cover rounded-lg cursor-pointer",
                                onClick: ($event: any) => (_ctx.openImagePreview(index))
                              }, null, 8, ["src", "alt", "onClick"]))
                        ]))
                      : (item.ext.replace('.', '').toLowerCase() === 'mov')
                        ? (_openBlock(), _createBlock("div", _hoisted_13, [
                            _createVNode("img", {
                              src: require(`@/app/ui/assets/svg/play-mov.svg`),
                              alt: "MOV",
                              class: "h-10 w-10 object-cover rounded-lg cursor-pointer",
                              onClick: () => _ctx.openInNewTab(item.url)
                            }, null, 8, ["src", "onClick"])
                          ]))
                        : (_openBlock(), _createBlock("img", {
                            key: 2,
                            src: 
                  'data:image/svg+xml;utf8,' +
                    encodeURIComponent(
                      `<svg viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M9.69462 0H24L36 12V34.7926C36 37.6711 33.5088 40 30.4403 40H9.57031C6.49114 40 4 37.6711 4 34.7926V5.20733C3.99995 2.32878 6.61539 0 9.69462 0Z' fill='${_ctx.getFileColor(
                        item.ext.replace('.', '')
                      )}'/><path d='M24.0257 8.16V0L36 12H28.0171C24.4248 12 23.8593 9.44 24.0257 8.16Z' fill='white' fill-opacity='0.3'/></svg>`
                    )
                ,
                            alt: item.name,
                            class: "h-10 w-10 object-cover rounded-lg cursor-pointer",
                            onClick: () => _ctx.downloadFile(item.url)
                          }, null, 8, ["src", "alt", "onClick"])),
                    (!_ctx.isImageFile(item.ext.replace('.', '')) && item.ext.replace('.', '').toLowerCase() !== 'mov')
                      ? (_openBlock(), _createBlock("div", _hoisted_14, [
                          _createVNode("span", {
                            class: " text-10px font-bold absolute bottom-3 transform left-1/2 -translate-x-1/2 cursor-pointer",
                            style: {
                    color: item.ext.replace('.', '') === 'csv' ? '#626262' : '#ffffff'
                  },
                            onClick: () => _ctx.downloadFile(item.url)
                          }, _toDisplayString(item.ext.replace('.', '').toUpperCase()), 13, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showImagePreview)
      ? (_openBlock(), _createBlock(_component_ImagePreview, {
          key: 0,
          title: _ctx.$t('Lampiran'),
          images: 
        _ctx.attachment
          .filter((item) => _ctx.isImageFile(item.ext.replace('.', '')))
          .map((item) => item.url)
      ,
          "title-images": 
        _ctx.attachment
          .filter((item) => _ctx.isImageFile(item.ext.replace('.', '')))
          .map((item) => item.fileName)
      ,
          "initial-index": _ctx.selectedImage,
          onClose: _ctx.closeImagePreview
        }, null, 8, ["title", "images", "title-images", "initial-index", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}